export default "__VITE_ASSET__2635d987__"